<template>
  <el-form
    ref="formRef"
    :model="formData"
    :rules="formRules"
    @submit.native.prevent="handleSubmit"
    class="w-full"
  >
    <div class="w-full h-[2.92vw] flex justify-between items-center">
      <!-- 姓名输入 -->
      <el-form-item prop="name" class="!m-0">
        <el-input
          v-model="formData.name"
          placeholder="请输入您的姓名"
          class="custom-input w-[11.3vw]"
        >
        </el-input>
      </el-form-item>

      <!-- 手机号输入 -->
      <el-form-item prop="phone" class="!m-0">
        <el-input
          v-model="formData.phone"
          placeholder="请输入您的电话"
          class="custom-input w-[11.3vw]"
        >
        </el-input>
      </el-form-item>

      <!-- 提交按钮 -->
      <el-form-item class="!m-0">
        <el-button
          native-type="submit"
          class="flex mx-auto justify-center items-center custom-button"
          @mouseenter="hoverButton = true"
          @mouseleave="hoverButton = false"
        >
          提交申请
        </el-button>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import axios from "axios";
import {addUser, phoneIsExist} from "@/api/submitInfo";
// import SubmitDialog from "@/components/FormSubmit/SubmitDialog.vue";

export default {
  name: "JoinForm",
  components: {
    // SubmitDialog,
  },
  data() {
    return {
      // 表单数据
      formData: {
        name: "",
        phone: "",
        category: "",
      },
      // 表单校验规则
      formRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入有效的手机号",
            trigger: "blur",
          },
        ],
      },
      hoverButton: false,
    };
  },
  methods: {

    // 检查手机号是否已存在
    async checkPhoneExistence(phone, category) {
      const baseUrl = "/api";
      // const phoneFilter = `?filters[phone][$eq]=${phone}`;
      // const catenpm goryFilter = `&filters[category][$eq]=${category}`;
      // const processFilter = `&filters[process][$eq]=pending_待处理`;

      try {
          const response = await phoneIsExist(phone,category,"pending_待处理")
          // console.log(response)
          return response.resultCode === 0;
      } catch (error) {
        console.error("检查手机号是否存在时出错", error);
        return false;
      }
    },

    // 检查一分钟内提交次数是否超过限制
    // isSubmitLimitReached() {
    //     debugger;
    //   const submitData = JSON.parse(localStorage.getItem("submitData") || "[]");
    //   const oneMinuteAgo = Date.now() - 60 * 1000;
    //   const recentSubmissions = submitData.filter(
    //     (item) => item.timestamp > oneMinuteAgo
    //   );
    //
    //   // 如果一分钟内提交次数超过限制，返回 true
    //   if (recentSubmissions.length >= 20) {
    //     return true;
    //   }
    //
    //   // 未超限时记录本次提交
    //   submitData.push({ timestamp: Date.now() });
    //   localStorage.setItem("submitData", JSON.stringify(submitData));
    //   return false;
    // },
      isSubmitLimitReached() {
          const key = "form_submit_limit";
          const now = Date.now();
          const oneMinuteAgo = now - 60 * 1000;
          const maxSubmits = 1; // 设置最大提交次数

          try {
              const history = JSON.parse(localStorage.getItem(key)) || [];

              // 过滤出一分钟内的提交记录
              const recentSubmits = history.filter(time => time > oneMinuteAgo);
              console.log(recentSubmits.length >= maxSubmits)
              if (recentSubmits.length >= maxSubmits) {
                  this.$notify.warning({
                      title: '提交频繁',
                      message: `每分钟最多可提交 ${maxSubmits} 次，请稍后再试。`
                  });
                  return true;
              }

              // 添加本次提交时间并保存
              recentSubmits.push(now);
              localStorage.setItem(key, JSON.stringify(recentSubmits));
              return false;
          } catch (error) {
              console.error("提交限制检查失败", error);
              return false;
          }
      },
    // 重置表单
    resetForm() {
      this.formData = {
        name: "",
        phone: "",
        category: "",
      };
      this.$refs.formRef.resetFields();
    },

    // 提交前验证表单
    async handleSubmit() {
      // 动态设置 category 字段
      const currentUrl = window.location.href.toLowerCase();
      if (
        currentUrl.includes("coursesystem") ||
        currentUrl.includes("competition")
      ) {
        this.formData.category = "course_试听";
      } else {
        this.formData.category = "join_加盟";
      }

      // 检查表单是否填写了必要字段（姓名和手机号）
      if (!this.formData.name || !this.formData.phone) {
        this.$notify.error({
          title: "提交失败",
          message:
            "姓名或号码为空，请填写后提交！<br>如需咨询，欢迎拨打服务热线：<br><span style='color: #05358C; font-size: 1.04vw;'>400 0336 691</span>",
          dangerouslyUseHTMLString: true,
        });
        return;
      }
      // 检查一分钟内是否超过提交次数
      if (this.isSubmitLimitReached()) {
        // this.$notify.error({
        //   title: "提交失败",
        //   message:
        //     "当前系统表单提交繁忙，请稍候再试！<br>如需咨询，欢迎拨打服务热线：<br> <span style='color: #05358C; font-size: 1.04vw;'>400 0336 691</span>",
        //   dangerouslyUseHTMLString: true,
        // });
        return;
      }
      // 校验手机号是否已存在
      const phoneCheckResponse = await this.checkPhoneExistence(
        this.formData.phone,
        this.formData.category
      );
      if (phoneCheckResponse) {
        this.$notify.error({
          title: "提交失败",
          message:
            "此手机号码已登记，请勿重复提交！<br>如需咨询，欢迎拨打服务热线：<br> <span style='color: #05358C; font-size: 1.04vw;'>400 0336 691</span>",
          dangerouslyUseHTMLString: true,
        });
        return;
      }

      // 验证表单
      const valid = await this.$refs.formRef.validate();
      if (!valid) {
        return;
      }

      // 提交表单数据
      await this.submitForm();
    },

    // 发送表单数据到后端
    async submitForm() {
      this.formData.process = "pending_待处理";
      // const baseUrl = "/api";
      try {
        // 打印提交数据
        // console.log("提交的数据：", this.formData);

        // 发送表单数据
        /*const response = await axios.post(`${baseUrl}/submitinfo/addUser`, {
          data: this.formData,
        });*/
          const response =  await  addUser(this.formData);

          if(response.resultCode !== 0){
              throw new Error(response.message);
          }

        console.log("数据提交成功", response);
        this.$notify.success({
          title: "提交成功",
          message:
            "信息已登记，我们会尽快与您联系！<br>如需咨询，欢迎拨打服务热线：<br> <span style='color: #05358C; font-size: 1.04vw;'>400 0336 691</span>",
          dangerouslyUseHTMLString: true,
        });
        this.resetForm();
      } catch (error) {
        this.$notify.error({
          title: "提交失败",
          message:
            "信息提交异常！<br>如需咨询，欢迎拨打服务热线：<br> <span style='color: #05358C; font-size: 1.04vw;'>400 0336 691</span>",
          dangerouslyUseHTMLString: true,
        });
      }
    },
  },
};
</script>

<style scoped>
/* 自定义输入框样式 */
.custom-input {
  width: 11.3vw !important;
  height: 2.92vw !important;
}

.custom-input :deep(.el-input__inner) {
  height: 100% !important;
  padding: 0.63vw 1.63vw !important;
  font-size: 0.83vw !important;
  color: #b4b8bf !important;
  border-radius: 0.25vw !important;
  font-family: HarmonyOS Sans SC !important;
}

/* 聚焦时字体颜色为黑色 */
.custom-input :deep(.el-input__inner:focus) {
  color: #000 !important;
}

/* 自定义按钮样式 */
.custom-button {
  width: 6.87vw;
  height: 2.92vw;
  background: #f28334 !important;
  border: none;
  border-radius: 0.25vw;
  transition: all 0.3s;
}

.custom-button :deep(span) {
  color: white;
  font-size: 1.04vw;
  font-weight: bold;
  font-family: "HarmonyOS Sans SC";
}

.custom-button:hover {
  transform: scale(1.05);
  box-shadow: 0 0.2vw 0.6vw rgba(242, 131, 52, 0.5);
}
</style>